// Global fetch controller
import {
    GLOBAL_FETCH_CONTROLLER,
    resetFetchController
} from "../stores/actions/settings";
// Redux
import { applyMiddleware, createStore } from 'redux';
// Persistant data localstorage
import { createMigrate, createTransform, persistReducer, persistStore } from 'redux-persist';

// Development helpers middleware
import { composeWithDevTools } from "redux-devtools-extension";
// import logger from 'redux-logger';
// Migrate internal state
import migrations from './migrations';
// Redux reducers
import rootReducer, { LIST_SANITIZERS } from './reducers'
// Improved localstoreage for redux-persist
import storage from 'localforage';
// Async actions flow 
import thunk from 'redux-thunk';

const abortOnLogoutMiddleware = store => next => action => {
    // Abort all fetches on logout
    if (action.type === "LOGOUT") {
        GLOBAL_FETCH_CONTROLLER.abort();
        // Restart
        resetFetchController();
    }
    next(action);
}

let middleware;
// if (process.env.NODE_ENV === 'production') {
middleware = [thunk, abortOnLogoutMiddleware];
// } else {
// middleware = [thunk, abortOnLogoutMiddleware, logger];
// }


const NON_PERSISTED_FIELDS = {
    // clients: always fetched fresh, an error response cached here once broke the clients page
    // reset sensor error counts flags: so the snackbar doesn't show up again after a reload
    dashboard: ['systemsForTable', 'systemsForTableLoading', 'clients', 'inspectionPerformers',
        'resetSensorErrorCountsSuccess', 'resetSensorErrorCountsFailed'],
    installer: ['systemDetails', 'systemDetailsLoading', 'deviceDetails', 'deviceDetailsLoading'],
};

const stripNonPersistedFields = (state, key) => {
    const fields = NON_PERSISTED_FIELDS[key];
    if (!fields) {
        return state;
    }
    const stripped = { ...state };
    fields.forEach((field) => delete stripped[field]);
    return stripped;
};

// stripped when saving and when restoring, so that values stored before a field was added here are dropped too
const dropFetchOnMountData = createTransform(
    stripNonPersistedFields,
    stripNonPersistedFields,
    { whitelist: Object.keys(NON_PERSISTED_FIELDS) }
);

// lists cached before the state was guarded (see reducers/guardListKeys.ts) - redux-persist merges the restored
// state without running the reducers, so it's checked here, before anything is rendered from it
const sanitizeRestoredLists = createTransform(
    (inboundState) => inboundState,
    (outboundState, key) => LIST_SANITIZERS[key] ? LIST_SANITIZERS[key](outboundState) : outboundState,
    { whitelist: Object.keys(LIST_SANITIZERS) }
);

const persistConfig = {
    key: 'root',
    storage,
    // bumped 3 -> 4 (see stores/migrations.js: 2 and 3 both wipe) to flush any locally cached
    // session that predates this round of backend/frontend changes
    version: 4,
    migrate: createMigrate(migrations, { debug: process.env.NODE_ENV === 'development' }),
    transforms: [dropFetchOnMountData, sanitizeRestoredLists],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

let Store = createStore(
    persistedReducer,
    // applyMiddleware(...middleware),
    composeWithDevTools(applyMiddleware(...middleware))
)

let Persistor = persistStore(Store);


window.addEventListener('storage', (e) => {
  if (e.key === 'w4-token' && !e.newValue) {
    Store.dispatch({ type: 'LOGOUT' });
  }
});

export {
    Store,
    Persistor
};